export default "/images/2f883a676da04ca51e486985d2b6bea9.avif";